import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_COMPANY_SUBSCRIPTION = "SET_COMPANY_SUBSCRIPTION";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SET_COMPANY_VALID_SUBSCRIPTION = "SET_COMPANY_VALID_SUBSCRIPTION";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

export function setCompanySubscriptions(companySubscriptions) {
  return {
    type: SET_COMPANY_SUBSCRIPTION,
    payload: companySubscriptions,
  };
}

export function setCompanyValidSubscriptions(companyValidSubscriptions) {
  return {
    type: SET_COMPANY_VALID_SUBSCRIPTION,
    payload: companyValidSubscriptions,
  };
}

// function setSubscriptionRequest(subscriptionRequest) {
//   return {
//     type: SET_SUBSCRIPTION,
//     payload: subscriptionRequest,
//   };
// }

export function getCompanySubscriptions(token, company) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/subscriptions?company=${company}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setCompanySubscriptions(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function getCompanyValidSubscriptions(token, company) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/subscriptions?company=${company}&valid=${true}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setCompanyValidSubscriptions(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function checkCompanySubscription(token, company, service, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/subscriptions/check?company=${company}&service=${service}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data.data);
      

      if (response.data.data && typeof response.data.data === "object") {
        callback({
          success: true,
          active: true,
          message: response.data.message,
        });
      } else {
        callback({
          success: true,
          active: false,
          message: response.data.message,
        });
      }
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function handleSubscribe(token, subscriptionData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/subscriptions`,
        subscriptionData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // await dispatch(setSubscriptionRequest(response.data.data));
      callback({
        success: true,
        data: response.data.data,
        message: response.data.message,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

// Staff: companies with their monthly and yearly subscriptions
export function getSubscriptionsOverview(token, includeExpired, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/subscriptions/overview${includeExpired ? "?expired=true" : ""}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      callback({ success: true, data: response.data.data || [] });
    } catch (error) {
      callback({
        success: false,
        data: [],
        message:
          error.response?.data?.message ||
          error.message ||
          "Une erreur inattendue est survenue.",
      });
    }
  };
}
